export default __webpack_public_path__ + "static/media/xing_black.aa133cc6.svg";